/**
 * Produces the set difference of two sequences.
 */

export function except<T>(array1: Array<T>, array2: Array<T>): Array<T> {
	return array1.reduce((aggregate, value) => {
		if (!array2.includes(value)) {
			aggregate.push(value);
		}

		return aggregate;
	}, []);
}
